import{reduce as n}from"./reduce.js";function r(r){return n("function"==typeof r?function(n,t){return r(n,t)<0?n:t}:function(n,r){return n<r?n:r})}export{r as min};
